<template>
  <div class="search-section">
    <div class="search-section__label">
      <slot name="title" />
    </div>

    <div>
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.search-section {
  &__label {
    padding: 8px 16px;
    font-size: 1.4rem;
    font-weight: bold;
    background-color: $gray-2;
    text-align: left;
  }
}
</style>
